export default "__VITE_ASSET__D28tP8Pj__"